import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import staticData from "../../assests/staticData.json";

export default function ServiceList() {
  const { service_list } = staticData;
  return (
    <div className="service-list-content">
      <h4>Our Services</h4>
      <ul>
        {service_list.map((list, index) => (
          <li key={index}>
            <div className="service-list-box-wrapper">
              <div className="list-box-icon">
                <span>
                  <FontAwesomeIcon icon={faArrowRightLong} />
                </span>
              </div>
              <div className="list-box-desc">
                <Link to={list.list_link}>{list.list_title}</Link>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
